import React, { useContext } from 'react';
import { UserContext } from '../../context/authContext';
import { format } from 'date-and-time';

const BottomWarningBar: React.FC = () => {
  const { companyAccount } = useContext(UserContext);
  const currentSub = companyAccount?.subscriptions.at(-1);
  const endingAt = format(
    new Date(currentSub?.current_period_end! * 1000),
    'ddd, MMM DD YYYY'
  );

  return (
    <div
      style={{
        width: '100%',
        height: '30px',
        backgroundColor: 'black',
        display: 'flex',
        alignItems: 'center',
        justifyContent: `${currentSub?.status === 'trialing' ? 'space-around' : 'center'}`,
        color: 'white',
        fontWeight: 'bold'
      }}
    >
      Koru AI can make mistakes. Please make sure to check important info.
      {currentSub?.status! === 'trialing' && (
        <p>{`Trial Account, ending ${endingAt}`}</p>
      )}
    </div>
  );
};

export default BottomWarningBar;
